import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  ViewChild,
} from '@angular/core';
import { CountryStats } from '../../../service/coursera-dashboard-stats.model';
import { Chart, ChartConfiguration } from 'chart.js';

@Component({
  selector: 'app-coursera-pays-chart',
  templateUrl: './coursera-pays-chart.component.html',
  styleUrls: ['./coursera-pays-chart.component.css'],
})
export class CourseraPaysChartComponent implements OnChanges {
  @Input() data: CountryStats[] = [];
  @ViewChild('paysChart') chartRef!: ElementRef;

  chart!: Chart;

  ngOnChanges(): void {
    // 🔥 si pas de données → laisser le template afficher noData
    if (!this.data || this.data.length === 0) return;

    // 🔥 attendre que le canvas soit rendu par *ngIf
    setTimeout(() => {
      this.createChart();
    });
  }

  createChart() {
    if (!this.chartRef?.nativeElement) return;

    const ctx = this.chartRef.nativeElement.getContext('2d');

    const labels = this.data.map((d) => this.truncateLabel(d.country));
    const values = this.data.map((d) => d.total);

    // 🔥 destroy ancien chart
    if (this.chart) {
      this.chart.destroy();
    }

    const config: ChartConfiguration = {
      type: 'bar',
      data: {
        labels,
        datasets: [
          {
            label: 'Nombre par pays',
            data: values,
          },
        ],
      },
      options: {
        responsive: true,
      },
    };

    this.chart = new Chart(ctx, config);
  }

  truncateLabel(label: string, maxLength: number = 12): string {
    return label.length > maxLength
      ? label.substring(0, maxLength) + '...'
      : label;
  }
}
